import React from 'react';

const Description = () => {
  return (
    <div className="desc">
      <img id="descImg" src={require('../../assets/upload.svg')} alt="upload cloud" />

      <div className="descText">
        <p className="descTextMain">
          <span className="blue-bottom">
            Upload</span> an image of the <span className="blue-bottom">tweet</span> you
            want to save, and access it at <span className="blue-bottom">any time
          </span>.
        </p>
      </div>
    </div>
  );
};

export default Description;